import { defineMessages } from '@kyruus/intl';

export const messages = defineMessages({
  staticMapLabel: {
    id: 'staticMap.label',
    description: 'aria label for the static map',
    defaultMessage: 'Street Map'
  }
});
